import { create, w, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { Tooltip, Orientation } from '@dojo/widgets/tooltip';
import { subscribe, publish } from '@holmescorp/pub-sub';
import { Keys } from '@holmescorp/common';
import { Icon } from '../icon';
import { ActionButton } from './action-button';
const icache = createICacheMiddleware();
const factory = create({ icache, theme }).properties();
export const MenuAction = factory(({ id, properties, middleware: { icache } }) => {
    const { onClick, onFocus, shouldFocus = false, altText, ttText, faname, xqa, isHighlighted = false } = properties();
    const ttActive = () => {
        onFocus && onFocus();
        icache.set('ttopen', true);
    };
    const ttHidden = () => icache.set('ttopen', false);
    subscribe('menuAction/hideAllTooltips', (action, sourceId) => {
        if (sourceId !== id) {
            ttHidden();
        }
    });
    let timeoutId;
    return w(Tooltip, { open: icache.getOrSet('ttopen', false), orientation: Orientation.bottom }, [
        {
            content: v('span', { onmouseover: () => clearTimeout(timeoutId), onmouseout: ttHidden }, [ttText]),
            trigger: w(ActionButton, {
                aria: {
                    label: altText || ''
                },
                shouldFocus,
                size: 'small',
                isAction: true,
                onClick,
                onOver: () => {
                    publish('menuAction/hideAllTooltips', id);
                    ttActive();
                },
                onOut: () => {
                    timeoutId = setTimeout(() => ttHidden(), 500);
                },
                onFocus: ttActive,
                onBlur: ttHidden,
                onKeyDown: (event) => {
                    if (event.key === Keys.Escape) {
                        ttHidden();
                    }
                },
                isHighlighted
            }, [w(Icon, { faname, altText, xqa })])
        }
    ]);
});
